import { firebase, googleAuthProvider, db } from '../firebase/firebase-config';
import { types } from '../types/types';
import { nameInHashtag, getZonaHoraria, getLadaPorZona, getEmpresaByUid } from '../helpers/util';
import Swal from 'sweetalert2';

/*const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || 
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);*/
const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);    

export const startGoogleLogin = () => {
    return async (dispatch) => {
        try {
            console.log('userAgent:', navigator.userAgent);
            console.log('isIOS:', isIOS());
            if (isIOS()) {
                console.log('isIOS detectado, usando redirect...');
                console.log('userAgent:', navigator.userAgent);
                // iOS: usar redirect pero con persistencia LOCAL para sobrevivir la navegación
                await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
                await firebase.auth().signInWithRedirect(googleAuthProvider);
                return;
            }

            const result = await firebase.auth().signInWithPopup(googleAuthProvider);
            const user = result.user;
            const accessToken = result.credential.accessToken;

            const empresa = await getEmpresaByUid(user.uid);

            if (empresa) {
                dispatch({
                    type: types.login,
                    payload: {
                        uid: user.uid,
                        displayName: user.displayName,
                        email: user.email,
                        photoURL: user.photoURL,
                        accessToken,
                        hashtag: empresa.id,
                        nombre: empresa.nombre,
                        zonaHoraria: empresa.zonaHoraria || getZonaHoraria(),
                        ladaPais: empresa.ladaPais || getLadaPorZona(empresa.zonaHoraria),
                        onboardingCompleto: empresa.onboardingCompleto || false,
                    }
                });
            } else {
                dispatch({
                    type: types.login,
                    payload: {
                        uid: user.uid,
                        displayName: user.displayName,
                        email: user.email,
                        photoURL: user.photoURL,
                        accessToken,
                        onboardingCompleto: false,
                    }
                });
            }
        } catch (e) {
            console.error(e);
            Swal.fire('Error', 'No se pudo iniciar sesión con Google', 'error');
        }
    };
};
/*export const startGoogleLogin = () => {
    return async (dispatch) => {
        try {
            await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
            await firebase.auth().signInWithRedirect(googleAuthProvider);
        } catch (e) {
            console.error(e);
        }
    };
};*/

export const startLogout = () => {
    return async (dispatch) => {
        await firebase.auth().signOut();
        dispatch({ type: types.logout });
    };
};

export const guardarNombreEmpresa = (nombre) => {
    return async (dispatch, getState) => {
        const { uid } = getState().auth;
        const zonaHoraria = getZonaHoraria();
        const ladaPais = getLadaPorZona(zonaHoraria);
        const hashtag = await nameInHashtag(nombre);

        await db.collection('general').doc(hashtag).set({
            uid,
            hashtag,
            nombre,
            zonaHoraria,
            ladaPais,
            stripe: { customerId: 'stripe_112159' },
            numero_whatsapp: 'compartido',
            calendario: 'nuevo',
        });

        dispatch({
            type: types.authUpdateEmpresa,
            payload: { hashtag, nombre, zonaHoraria, ladaPais }
        });

        return hashtag;
    };
};

export const guardarDireccion = (datos) => {
    return async (dispatch, getState) => {
        const { hashtag } = getState().auth;
        await db.doc(`general/${hashtag}`).update({
            direccion: datos.direccion,
            maps: datos.maps,
            telefonos_contacto: datos.telefonos,
            tolerancia: String(datos.tolerancia ?? '-1'),
        });
        dispatch({ type: types.authUpdateEmpresa, payload: datos });
    };
};

export const guardarSpei = (spei) => {
    return async (dispatch, getState) => {
        const { hashtag } = getState().auth;
        await db.doc(`general/${hashtag}`).update({ spei });
        dispatch({ type: types.authUpdateEmpresa, payload: { spei } });
    };
};

export const cargarDatosEmpresa = () => {
    return async (dispatch, getState) => {
        const { hashtag } = getState().auth;
        if (!hashtag) return null;
        const snap = await db.doc(`general/${hashtag}`).get();
        if (snap.exists) {
            const data = snap.data();
            dispatch({ type: types.authUpdateEmpresa, payload: {
                direccion: data.direccion,
                linkGoogleMaps: data.maps,
                telefonos_contacto: data.telefonos_contacto,
                tolerancia: data.tolerancia,
                spei: data.spei,
            }});
            return data;
        }
        return null;
    };
};

export const marcarOnboardingCompleto = () => {
    return async (dispatch, getState) => {
        const { hashtag } = getState().auth;
        await db.doc(`general/${hashtag}`).update({ onboardingCompleto: true });
        dispatch({ type: types.authUpdateEmpresa, payload: { onboardingCompleto: true } });
    };
};

export const actualizarZonaHoraria = (zonaHoraria, ladaPais) => {
    return async (dispatch, getState) => {
        const { hashtag } = getState().auth;
        if (hashtag) {
            await db.doc(`general/${hashtag}`).update({ zonaHoraria, ladaPais });
        }
        dispatch({ type: types.authUpdateEmpresa, payload: { zonaHoraria, ladaPais } });
    };
};
